module.exports = __webpack_public_path__ + "img/Institut Français_India_HD-01.b27c47e0.png";